module.exports = __webpack_public_path__ + "static/media/Extruded tooth11.4337463a.png";